var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{attrs:{"id":"side-nav"}},_vm._l((_vm.menu),function(item){return _c('SideNavItem',{key:item.label,attrs:{"path":item.path,"items":item.items,"label":item.label}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }